import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Flex, Heading, Box, Text } from "@chakra-ui/react";

import { Waypoint } from "react-waypoint";
import { useLocation } from "react-router-dom";
//images
import AboutBg from "../../assets/images/aboutbg.jpg";
import Who1 from "../../assets/images/who1.jpg";
import Team from "../../assets/images/team.jpg";

const About = () => {
  let params = useLocation();

  useEffect(() => {
    if (params?.state?.id)
      document.querySelector(`${params.state.id}`).scrollIntoView(true);
    else window.scrollTo(0, 0);
  }, [params.state, useLocation().state]);

  return (
    <Flex flexDirection={"column"} alignItems={"center"}>
      <Helmet>
        <title>AKIA | About</title>
        <meta
          name="keywords"
          content="Efficient Flare System Design using Aspen Flare System"
        />
        <meta
          title="About - Best Consultant for conceptual Design for Process Plants"
          content="Buy the Top Quality Pipeline Hydraulic Analysis using Pipenet, Pipesim & Olga, we provide Efficient Flare System Design using Aspen Flare System at low cost."
        />
        <meta
          name="keywords"
          content="Top Quality Pipeline Hydraulic Analysis using for PIPENET, PIPESIM & OLGA"
        />
        <meta
          name="keywords"
          content="Best Consultant for Conceptual Design for Process Plants"
        />
      </Helmet>
      <Flex
        bg={`linear-gradient(rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.82)), url(${AboutBg})`}
        backgroundSize={"cover"}
        backgroundPosition={"bottom"}
        h={"100vh"}
        maxHeight={"1440px"}
        w="100vw"
        alignItems={"center"}
        justifyContent={"center"}
        color={"whiteAlpha.900"}
      >
        <Box
          width={"fit-content"}
          transform={{
            base: "",
            md: "translateX(-10vw)",
            lg: "translateX(-15vw)",
          }}
          px={"4rem"}
        >
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
          >
            <Waypoint
              onEnter={() =>
                (document.querySelector("#animateMain3").style.animation =
                  "heading 1.5s ease")
              }
            >
              <Flex id="animateMain3">
                <Heading
                  fontSize={{ base: "3.7rem", "3sm": "4.5rem", lg: "5.5rem" }}
                  textTransform={"uppercase"}
                  fontFamily={"Roboto Condensed, Lato, Sans-serif"}
                  flexShrink={"0"}
                  w={"100%"}
                  textAlign={{ base: "center", md: "left" }}
                >
                  About AKIA
                </Heading>
                <Box
                  bg={"whiteAlpha.900"}
                  h={"100%"}
                  w={"100%"}
                  flexShrink={"0"}
                ></Box>
              </Flex>
            </Waypoint>
          </Flex>
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
            mt={"1rem"}
          >
            <Waypoint
              onEnter={() =>
                (document.querySelector("#animateMain4").style.animation =
                  "heading 1.5s ease")
              }
            >
              <Flex id="animateMain4">
                <Text
                  textAlign={{ base: "justify", md: "left" }}
                  fontSize={"1.7rem"}
                  maxW={"50rem"}
                  flexShrink={"0"}
                  w={"100%"}
                >
                  AKIA Engineering is an Engineering firm committed to
                  innovative designs, sustainable solutions and high-quality
                  services for clients worldwide.
                </Text>
                <Box
                  bg={"whiteAlpha.900"}
                  h={"100%"}
                  w={"100%"}
                  flexShrink={"0"}
                ></Box>
              </Flex>
            </Waypoint>
          </Flex>
        </Box>
      </Flex>

      {/* Next Section */}
      <Flex
        py={"5rem"}
        px={{ base: "4rem", "3sm": "8rem" }}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Flex
          overflow={"hidden"}
          w={"fit-content"}
          maxW={"100rem"}
          pos={"relative"}
          id="special"
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animation9").style.animation =
                "heading 1.5s ease-out")
            }
          >
            <Flex id="animation9">
              <Heading
                textTransform={"uppercase"}
                fontSize={{ base: "3rem", "3sm": "4rem", lg: "5rem" }}
                textAlign="center"
                flexShrink={"0"}
                w={"100%"}
              >
                What makes us Special
              </Heading>
              <Box flexShrink={"0"} h={"100%"} w={"100%"} bg={"black"}></Box>
            </Flex>
          </Waypoint>
        </Flex>
        <Box bg={"#EA0F0F"} h="5px" w={"10rem"} mt={"2.5rem"}></Box>
        <Flex
          maxW={"1440px"}
          mt={"5rem"}
          gap={{ base: "4rem", lg: "8rem" }}
          justifyContent={"center"}
          alignItems={"center"}
          flexDir={{ base: "column-reverse", md: "row" }}
          w={"100%"}
        >
          <Flex
            textAlign={"justify"}
            flex={{ base: "0 0 48%", lg: "0 0 45%" }}
            flexDirection={"column"}
            fontSize={"1.8rem"}
          >
            <Flex
              overflow={"hidden"}
              w={"fit-content"}
              maxW={"100rem"}
              pos={"relative"}
            >
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#animate10").style.animation =
                    "heading 1.5s ease-out")
                }
              >
                <Flex id="animate10">
                  <Heading
                    fontSize={{ base: "2.2rem", "3sm": "3rem" }}
                    textTransform={"uppercase"}
                    mb={"1.5rem"}
                    flexShrink={"0"}
                  >
                    Who are we?
                  </Heading>
                  <Box
                    flexShrink={"0"}
                    h={"100%"}
                    w={"100%"}
                    bg={"black"}
                  ></Box>
                </Flex>
              </Waypoint>
            </Flex>
            <Text my={"1rem"}>
              AKIA Engineering provide Engineering services in a wide range of
              fields of Engineering such as Process, Piping, Mechanical,
              Instrumentation, Electrical, Structural/Civil and Flow assurance
              service for new and retrofit Oil & Gas (both offshore & Onshore),
              Petrochemical and Water treatment projects.
            </Text>
            <Text my={"1rem"}>
              We are an Engineering firm committed to innovative designs,
              sustainable solutions and high-quality services for clients
              worldwide. We are committed to provide an efficient, professional,
              safe and cost-effective service to its clients.
            </Text>
            <Text my={"1rem"}>
              Our engineers offer the best-in-class design Engineering services
              for a broad range of clients. AKIA Engineering designs and manages
              projects with an interdisciplinary and global approach,
              integrating specialized skills and proven experience.
            </Text>
            <Text my={"1rem"}>
              We view clients as partners where mutual respect, trust and
              integrity lead to long-term relationships over multiple projects
            </Text>
            <Text my={"1rem"}>
              We offer a service where quality, efficiency, value and safety are
              key fundamentals in operational functions
            </Text>
          </Flex>
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate11").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate11"
              flex={{ base: "0 0 300px", md: "0 0 48%", lg: "0 0 45%" }}
              bg={`url(${Who1})`}
              bgPosition={"center"}
              bgSize={"cover"}
              width={{ base: "100%", md: "" }}
              height={"60rem"}
              boxShadow={"0 0 10px 0 rgba(0, 0, 0, 0.5)"}
            ></Box>
          </Waypoint>
        </Flex>
      </Flex>

      {/* Next Section */}
      <Waypoint
        onEnter={() =>
          (document.querySelector("#animate12").style.animation = "fadeUp 1.5s")
        }
      >
        <Flex
          id="animate12"
          justifyContent={"center"}
          maxW={"1440px"}
          py={"5rem"}
          px={{ base: "3rem", "3sm": "8rem" }}
          w={"100%"}
          gap={{ base: "3rem", lg: "8rem" }}
          flexDir={{ base: "column", lg: "row" }}
        >
          <Flex
            bg={"#17262E"}
            px={{ base: "3rem", "3sm": "6rem" }}
            py={{ base: "3rem", "3sm": "4rem" }}
            flex={"0 0 50%"}
            flexDirection={"column"}
            color={"whiteAlpha.900"}
            textAlign={"justify"}
            boxShadow={"0 0 10px 0 rgba(0, 0, 0, 0.5)"}
            id="mission"
          >
            <Heading
              mb={"1.5rem"}
              fontSize={"3rem"}
              textTransform={"uppercase"}
            >
              Our Mission
            </Heading>
            <Text fontSize={"1.8rem"}>
              AKIA aims To build opportunities by respecting and nurturing
              relationships with our clients, employees and communities. We know
              that successful relationships lead to successful projects. Our aim
              is to maintain our commitments towards employees’ development,
              career and well-being and to continuously pursue enhancement of
              our capabilities and performance.
            </Text>
          </Flex>
          <Flex
            border={"2px solid #17262E"}
            px={{ base: "3rem", "3sm": "6rem" }}
            py={{ base: "3rem", "3sm": "4rem" }}
            flex={"0 0 50%"}
            flexDirection={"column"}
            textAlign={"justify"}
            boxShadow={"0 0 10px 0 rgba(0, 0, 0, 0.5)"}
            id="vision"
          >
            <Heading
              mb={"1.5rem"}
              fontSize={"3rem"}
              textTransform={"uppercase"}
            >
              Our Vision
            </Heading>
            <Text fontSize={"1.8rem"}>
              AKIA Engineering endeavor to be a leading Engineering consultancy
              firm in the Oil & Gas, Petrochemical and Water treatment fields.
              The Company aims to provide a continuity of work for the success
              of the company and its employees and developing Client/Consultant
              relationships, whilst carrying out high quality workmanship “built
              on trust” and an understanding of Client’s needs and requirements.
            </Text>
          </Flex>
        </Flex>
      </Waypoint>

      {/* Next Section */}
      <Flex
        py={"5rem"}
        px={{ base: "4rem", "3sm": "8rem" }}
        bg={"#FAFAFA"}
        w={"100vw"}
        flexDirection={"column"}
        alignItems={"center"}
        id="team"
      >
        <Flex width={"fit-content"} overflow={"hidden"} pos={"relative"}>
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate14").style.animation =
                "heading 1.5s ease-out")
            }
          >
            <Flex id="animate14">
              <Heading
                flexShrink={"0"}
                textTransform={"uppercase"}
                fontSize={{ base: "3rem", "3sm": "4rem", lg: "5rem" }}
              >
                Our Team
              </Heading>
              <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
            </Flex>
          </Waypoint>
        </Flex>
        <Box bg={"#EA0F0F"} h="5px" w={"10rem"} mt={"2.5rem"}></Box>

        <Flex
          maxW={"1440px"}
          mt={"5rem"}
          gap={{ base: "4rem", lg: "8rem" }}
          justifyContent={"center"}
          w={"100%"}
          flexDir={{ base: "column", md: "row" }}
        >
          <Waypoint
            onEnter={() =>
              (document.querySelector("#animate13").style.animation =
                "fadeUp 1.5s")
            }
          >
            <Box
              id="animate13"
              flex={{ base: "0 0 300px", md: "0 0 48%", lg: "0 0 45%" }}
              bg={`url(${Team})`}
              bgPosition={"center"}
              bgSize={"cover"}
              boxShadow={"0 0 10px 0 rgba(0, 0, 0, 0.5)"}
            ></Box>
          </Waypoint>

          <Flex
            textAlign={"justify"}
            flex={{ base: "0 0 48%", lg: "0 0 45%" }}
            flexDirection={"column"}
            fontSize={"1.8rem"}
          >
            <Flex width={"fit-content"} overflow={"hidden"} pos={"relative"}>
              <Waypoint
                onEnter={() =>
                  (document.querySelector("#animate15").style.animation =
                    "heading 1.5s ease-out")
                }
              >
                <Flex id="animate15">
                  <Heading
                    fontSize={"3rem"}
                    textTransform={"uppercase"}
                    mb={"1.5rem"}
                    flexShrink={"0"}
                  >
                    The Engineers
                  </Heading>
                  <Box w={"100%"} h={"100%"} bg={"black"} flexShrink={"0"} />
                </Flex>
              </Waypoint>
            </Flex>
            <Text my={"1rem"}>
              AKIA Engineering have a well-qualified, highly motivated team of
              Engineering professionals who have extensive working experience
              (20+ Years) with leading operating companies in India and Middle
              East.
            </Text>
            <Text my={"1rem"}>
              AKIA Engineering team of Engineering professionals assists in
              maintaining the highest standard of customer service. Our clients
              are assured they are dealing with a decision maker who is keenly
              aware of the importance of success on each and every project no
              matter the size.
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.5rem", md: "4rem" }}
        >
            Connect with us
        </Heading>
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>
          <a
                      id="phone"
                      style={{ flex: "0 0 22%" }}
                      href="https://wa.me/+971501232838"
                    >
                      
                        <Heading fontSize={"4rem"}>
                          <i
                            className="fa-brands fa-square-whatsapp"
                            style={{ color: "green" }}
                          />
                        </Heading>
                        
                        
                      
                    </a>

          <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default About;
